import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles(
    (theme: Theme) => ({
        customerInfoContent: {
            display: 'flex',
            alignContent: 'center',
            marginTop: '1rem',
            marginBottom: '1rem',
            alignItems: 'flex-start',
            '@media (max-width: 767px)': {
                flexDirection: 'column'
            }
        },
        displayAddressValue: {
            width: '20rem'
        },
        summaryDivider: {
            marginTop: '0.5rem',
            marginBottom: '0.6rem',
            height: '2px'
        },
        bgBlue: {
            backgroundColor: theme.palette.primary.main,
        },
        gridMainContainer: {
            maxWidth: '1280px',
            margin: 'auto',
            padding: '1rem 1rem 2.5rem 1rem',
        },
    }),
    { index: 1 },
);
